/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PhotoInputs */

const cs_col_photo = /** @type {(inputs: Col_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

const en_col_photo = /** @type {(inputs: Col_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Col_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_photo = /** @type {((inputs?: Col_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_photo(inputs)
	return cs_col_photo(inputs)
});